import React from 'react'

// material-ui
import Typography from '@mui/material/Typography'

const InvalidFormHelper = ({ invalid, helpText }) => {
  if (!invalid) {
    return null
  }

  return (
    <Typography variant='body1' fontWeight='bold' align='center' my={1}>
      {helpText}
    </Typography>
  )
}

export default InvalidFormHelper
